import { Component, input } from '@angular/core';

import { ApCardComponent } from '@ap/card';
import { ApImageCardComponent } from '@ap/card/image';
import { ApContentComponent } from '@ap/content';
import { ApListIconComponent, AvailableIcons } from '@ap/icon';
import { ApPanelHeaderDirective, ApPanelComponent } from '@ap/panel';

/* eslint-disable-next-line @typescript-eslint/no-unsafe-function-type, @typescript-eslint/naming-convention */
const DisableLifecycleHooks = (constructor: Function) => {
    constructor.prototype.ngOnInit = () => {};
    constructor.prototype.ngOnChanges = () => {};
    constructor.prototype.ngOnDestroy = () => {};
    constructor.prototype.ngDoCheck = () => {};
    constructor.prototype.ngAfterContentInit = () => {};
    constructor.prototype.ngAfterContentChecked = () => {};
    constructor.prototype.ngAfterViewInit = () => {};
    constructor.prototype.ngAfterViewChecked = () => {};
};

@Component({
    template: `<li class="cc" apListIcon [name]="name()" [color]="color()"><ng-content></ng-content></li>`,
    imports: [ApListIconComponent]
})
@DisableLifecycleHooks
export class ApIconListItemWrapperComponent {
    public readonly name = input<string>();
    public readonly color = input<string>();
}

@Component({
    template: `<ap-panel [title]="title()" [type]="type()">
        @if (header()) {
            <h2 apPanelHeader>{{ header() }}</h2>
        }
        @if (body()) {
            <div ap-panel-body><ap-content [key]="body()"></ap-content></div>
        }
    </ap-panel>`,
    imports: [ApPanelComponent, ApPanelHeaderDirective, ApContentComponent]
})
@DisableLifecycleHooks
export class ApPanelWrapperComponent {
    public readonly type = input<'primary' | 'secondary' | 'tertiary'>('primary');
    public readonly title = input<string>();
    public readonly header = input<string>();
    public readonly body = input<string>();
    public readonly icon = input<string>();
}
@Component({
    template: `<ap-card [title]="title()" [iconName]="iconName()" [iconAriaLabel]="iconAriaLabel()">
        @if (header()) {
            <h2 apCardHeader [innerHTML]="header()"></h2>
        }
        <ng-content></ng-content>
    </ap-card>`,
    imports: [ApCardComponent]
})
@DisableLifecycleHooks
export class ApCardWrapperComponent {
    public readonly header = input<string>();
    public readonly body = input<string>();
    public readonly title = input<string>();
    public readonly iconName = input<AvailableIcons>();
    public readonly iconAriaLabel = input<string>();
}
@Component({
    template: `<ap-image-card [type]="type()" [imageSource]="imageSource()" [alt]="alt()">
        <ng-content></ng-content>
    </ap-image-card>`,
    imports: [ApImageCardComponent]
})
@DisableLifecycleHooks
export class ApImageCardWrapperComponent {
    public readonly type = input<'vertical' | 'horizontal'>('vertical');
    public readonly imageSource = input<string>();
    public readonly alt = input<string>();
}
